import {useState, useEffect, useRef} from 'react';
import enumList from 'web/utils/enumList';
import {useNavigate} from 'react-router-dom';
import {
  DataTableComponent,
  batchCheckControls,
} from '../../../components/CommonComponent';
import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  FLG_CLOSE,
  FLG_OPEN,
} from 'web/constant';
import $, {get} from 'jquery';
import {fetchDispatchList} from 'web/redux/actions/DispatchActions';
import {fetchEmployeeList} from 'web/redux/actions/EmployeeActions';
import {useDispatch} from 'react-redux';
import moment from 'moment';
export const useDispatchManagement = (showMessage, baseComponent) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dispatchList, setDispatchList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const tableRef = useRef(null);
  const getDispatchList = (
    casePriority,
    available,
    startTime,
    endTime,
    salesOrderNo,
    invoiceNo,
    quotationNo,
  ) => {
    if (!tableRef.current) prepareTable([]);
    tableRef.current.processing(true);

    dispatch(
      fetchDispatchList({
        casePriority,
        available,
        startTime,
        endTime,
        requireSameDepartment: true,
        salesOrderNo,
        invoiceNo,
        quotationNo,
      }),
    )
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode.isSuccessCode()) {
          const dispatchListRes = res.payload.result;
          setDispatchList(dispatchListRes);
          prepareTable(dispatchListRes);
          tableRef.current.processing(false);
        } else {
          showMessage(enumList.messageModalMode.error, res.payload.message);
          console.error('fetchCaseList error', res);
        }
      })
      .catch((err) => {
        console.error('fetchCaseList error', err);
      });
  };
  const checkStatus = (dispatchItem) => {
    const {employees, workEndTime, flgStatus} = dispatchItem;
    let status = flgStatus;
    if (employees?.length === 0) {
      status = enumList.assignmentFlgStatus.NONE.value;
    }
    if (
      moment(workEndTime).isBefore(moment()) &&
      flgStatus !== enumList.assignmentFlgStatus.FINISH.value
    ) {
      status = enumList.assignmentFlgStatus.EXPIRED.value;
    }
    return status;
  };

  const prepareTable = (dispatchList) => {
    // 定義資料內容
    const dataSet = dispatchList.map((dispatchItem) => {
      return [
        dispatchItem.cases._casePriority, // 0
        dispatchItem.cases._caseNumber, // 1
        dispatchItem.cases._createTime, // 2
        dispatchItem.cases._customerName, // 3
        dispatchItem.cases._description, // 4
        dispatchItem.cases._createUser, // 5
        dispatchItem.cases._conditionModels, // 6
        dispatchItem.machineSerialNumber, // 7
        dispatchItem.salesOrderNo, // 8
        dispatchItem.invoiceNo, // 9
        dispatchItem.quotationNo, // 10
        checkStatus(dispatchItem), // 11
        moment(dispatchItem.workStartTime).isValid()
          ? moment(dispatchItem.workStartTime).format('YYYY-MM-DD HH:mm:ss')
          : '', // 12
        moment(dispatchItem.workEndTime).isValid()
          ? moment(dispatchItem.workEndTime).format('YYYY-MM-DD HH:mm:ss')
          : '', // 13
        dispatchItem.employees?.length > 0 ?? '未指派', // 14
        dispatchItem.flgStatus, // 15
        null, // 16
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {
        title: '案件等級',
        className: 'dt-center',
        data: 0,
        render: (data, type, row, meta) => {
          // let enableId = 'eab-elevator-' + meta.row;
          const casePriority =
            data === enumList.casePriority.high
              ? CASE_PRIORITY_HIGH
              : CASE_PRIORITY_NORMAL;
          const labelStyle =
            data === enumList.casePriority.high ? 'status-rush' : '';
          return ` <div class="status ${labelStyle} "> <span>${casePriority}</span> </div>`;
        },
      },
      {title: '案件編號', className: 'dt-center', data: 1},
      {
        title: '立案時間',
        className: 'dt-center',
        data: 2,
        render: DataTable.render.datetime('YYYY-MM-DD'),
        type: 'datetime',
      },
      {title: '客戶名稱', className: 'dt-center', data: 3},
      {title: '案件內容', className: 'dt-center text-truncate', data: 4},
      {title: '立案人', className: 'dt-center', data: 5},
      {
        title: '指派條件',
        className: 'dt-center',
        data: 6,
        render: (data, type, row, meta) => {
          if (!data || data.length === 0) return '';
          return data.map((item) => item._conditionName).join('<br/>'); // 或用逗號分隔也可以
        },
      },
      {
        title: '機械番號',
        className: 'dt-head-center',
        data: 7,
      },
      {title: '銷貨單號', className: 'dt-center', data: 8},
      {title: '發票號碼', className: 'dt-center', data: 9},
      {title: '報價單號', className: 'dt-center', data: 10},
      {
        title: '派工狀態',
        className: 'dt-head-center',
        data: 11,
        render: (data, type, row, meta) => {
          // let enableId = 'eab-elevator-' + meta.row;
          const status = Object.values(enumList.assignmentFlgStatus).find(
            (v) => v.value === data,
          );

          return ` <div class="status ${status.variation} mb-2">
           <span>${status.text}</span> 
           </div>`;
        },
      },
      {title: '工作開始時間', className: 'dt-head-center', data: 12},
      {title: '工作結束時間', className: 'dt-head-center', data: 13},
      {
        orderable: false,
        order: null,
        title: '查看指派紀錄',
        className: 'dt-center',
        data: 14,
        render: (data, type, row, meta) => {
          const editId = 'edit-dispatch-' + meta.row;
          const updateButton = baseComponent.checkPermission(
            enumList.moduleEnums.dispatchManagement,
            enumList.accessModeEnums.update,
          )
            ? `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                              <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                  <use href="#ico-edit"></use>
                              </svg>
                              查看
                          </button>`
            : '';
          return `
                          <div class="btn-group" role="group" aria-label="">
                              ${updateButton}
                          </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        title: '預覽服務報告書',
        className: 'dt-center',
        data: 15,
        render: (data, type, row, meta) => {
          const isFinished = data === enumList.assignmentFlgStatus.FINISH.value;
          const previewButton = `<button type="button" ${
            isFinished ? '' : 'disabled'
          }   class="btn btn-sm btn-link" id="preview-dispatch-${meta.row}">
                              <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                  <use href="#ico-preview"></use>
                              </svg>
                              預覽
                          </button>`;

          return `
                          <div class="btn-group" role="group" aria-label="">
                              ${previewButton}
                          </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        title: '單號填寫',
        className: 'dt-center',
        data: 16,
        render: (data, type, row, meta) => {
          const previewButton = `
            <button type="button" 
              class="btn btn-sm btn-link" id="order-dispatch-${meta.row}">
                <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                    <use href="#ico-edit"></use>
                </svg>
                  填寫
            </button>`;

          return `
                  <div class="btn-group" role="group" aria-label="">
                    ${previewButton}
                  </div>`;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      idx: 1,
      dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };

    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__dispatch')) {
      $('#datatable__dispatch').DataTable().destroy();
    }

    // 重新繪製datatable
    tableRef.current = DataTableComponent(
      '#datatable__dispatch',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true,
      true,
    );
    setDispatchList(dispatchList);
    batchCheckControls();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const searchForm = new FormData(e.target);
    const dispatchEmployeeValue = searchForm.get('searchDispatchEmployee');
    let available = undefined;

    if (dispatchEmployeeValue === 'O') {
      available = 'A';
    } else if (dispatchEmployeeValue === 'C') {
      available = 'I';
    }
    const startTime = searchForm.get('searchStartDate');
    const rawEndDate = searchForm.get('searchEndDate');
    const endTime = rawEndDate
      ? moment(rawEndDate + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss').format(
          'YYYYMMDDHHmmss',
        )
      : '';
    const casePriority = searchForm.get('searchCasePriority');
    const salesOrderNo = searchForm.get('searchSalesOrder');
    const invoiceNo = searchForm.get('searchInvoice');
    const quotationNo = searchForm.get('searchQuotationNo');
    getDispatchList(
      casePriority,
      available,
      startTime,
      endTime,
      salesOrderNo,
      invoiceNo,
      quotationNo,
    );
  };

  return {
    dispatchList,
    getDispatchList,
    handleSearch,
    // getEmployeeList,
    employeeList,
  };
};
